<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1719"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1723"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1733"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1731" /></clipPath></defs><g
     id="g1725"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1727"><g
         id="g1729"
         clip-path="url(#clipPath1733)"><g
           id="g1735"
           transform="translate(394,227)"><path
             d="m 0,0 v -193 c 0,-13.255 -10.745,-24 -24,-24 h -336 c -13.255,0 -24,10.745 -24,24 v 444 c 0,13.255 10.745,24 24,24 h 336 c 13.255,0 24,-10.745 24,-24 V 78.758"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1737" /></g><g
           id="g1739"
           transform="translate(148.0834,429.9999)"><path
             d="m 0,0 h 107.833 c 11.736,0 21.25,9.514 21.25,21.25 V 72 H -21.25 V 21.25 C -21.25,9.514 -11.736,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1741" /></g><g
           id="g1743"
           transform="translate(161.9998,50.0001)"><path
             d="m 0,0 h -112 v 63 349 h 73.667"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1745" /></g><g
           id="g1747"
           transform="translate(354,201)"><path
             d="M 0,0 V -151 H -112"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1749" /></g><g
           id="g1751"
           transform="translate(280.333,461.9999)"><path
             d="M 0,0 H 73.667 V -194.78"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1753" /></g><g
           id="g1755"
           transform="translate(202,50.0001)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1757" /></g><g
           id="g1759"
           transform="translate(456.9837,293.9363)"><path
             d="m 0,0 -79.898,-79.898 -67.419,-30.017 30.016,67.419 117.168,117.169 c 10.329,10.328 27.075,10.328 37.403,0 V 74.672 C 47.598,64.344 47.598,47.598 37.27,37.27 L 0,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1761" /></g><g
           id="g1763"
           transform="translate(374.894,216.2297)"><path
             d="M 0,0 -34.32,34.32"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1765" /></g><g
           id="g1767"
           transform="translate(481.3965,318.3492)"><path
             d="M 0,0 -37.403,37.403"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1769" /></g><path
           d="M 162,318 H 98 v 64 h 64 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1771" /><path
           d="M 162,208 H 98 v 64 h 64 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1773" /><path
           d="M 162,98 H 98 v 64 h 64 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path1775" /><g
           id="g1777"
           transform="translate(218.4026,349.6738)"><path
             d="M 0,0 22.247,-22.247 67.392,22.899"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1779" /></g><g
           id="g1781"
           transform="translate(218.4026,239.6738)"><path
             d="M 0,0 22.247,-22.247 67.392,22.899"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1783" /></g><g
           id="g1785"
           transform="translate(229.5259,107.4271)"><path
             d="M 0,0 45.146,45.146"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1787" /></g><g
           id="g1789"
           transform="translate(229.5259,152.5729)"><path
             d="M 0,0 45.146,-45.146"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1791" /></g></g></g></g></svg>
</template>
